import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Chip from 'components_new/atoms/Chip'
import Icon from 'components_new/atoms/Icon'

import ContentBox from 'components_new/molecules/ContentBox'
import GenericListItem from 'components_new/molecules/GenericListItem'
import SimpleTable from 'components_new/molecules/SimpleTable'

import Loading from './loading'

import { useParams } from 'utils/hooks'

import { useGroup } from 'redux/hooks/Groups'
import { useTranslation } from 'language/translator'

interface Props {
  sx?: SxProps
}

const GroupAbout = React.memo((props: Props) => {
  const { sx } = props

  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation()
  const group = useGroup(id)

  if (!group) {
    return <Loading />
  }

  // success
  return (
    <Box sx={{ ...sx }}>
      <ContentBox
        collapse={{
          active: true,
          unmountOnExit: true
        }}
        color="default"
        gutterBottom={true}
        header={{
          icon: { name: 'Info' },
          title: t('global', 'about')
        }}
      >
        <SimpleTable
          rows={[
            {
              cells: [
                t('global', 'owners'),
                group?.owners && group.owners.length > 0 ? (
                  <>
                    {group?.owners.map((owner) => (
                      <GenericListItem
                        disablePadding={true}
                        key={owner.id}
                        size="small"
                        sx={{ minWidth: 0 }}
                        title={owner.name}
                        variant="user"
                      />
                    ))}
                  </>
                ) : (
                  <Chip
                    icon={<Icon name="ErrorOutline" />}
                    label={t('global', 'no_owner')}
                    size="small"
                    color="warning"
                  />
                )
              ]
            },
            {
              cells: [
                t('global', 'access'),
                <Chip
                  key={'availability'}
                  icon={
                    <Icon
                      name={group?.is_private ? 'Private' : 'PublicOutlined'}
                    />
                  }
                  label={
                    group?.is_private
                      ? t('global', 'private')
                      : t('global', 'public')
                  }
                  size="xsmall"
                />
              ]
            },
            {
              cells: [
                t('global', 'feed'),
                <Chip
                  key={'availability'}
                  icon={
                    <Icon
                      name={
                        group?.show_on_home ? 'Visibility' : 'VisibilityOff'
                      }
                    />
                  }
                  label={
                    group?.show_on_home
                      ? t('global', 'active')
                      : t('global', 'inactive')
                  }
                  size="xsmall"
                />
              ]
            }
          ]}
        />
      </ContentBox>
    </Box>
  )
})

export default GroupAbout
